import { useTriggerEventContext } from '@components/utils/contexts/TriggerEventContext';
import LinkButton from '@components/utils/cta/linkButton';
import styled from '@emotion/styled';
import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
} from '@enums';
import {
    Enum_Modals_Trigger,
    EventCtaFragment,
    LinkCtaFragment,
    StoryToPlayFragment,
} from '@graphql/generated/graphql';
import { useCtaDeeplink } from '@hooks/useCtaDeeplink';
import { StoryPageCta } from '@lib/pimster-stories/types';
import { Button } from '@lib/uikit';

import { useStoryContext } from '../contexts/StoryContext';

interface Props {
    cta: StoryPageCta;
}

const Center = styled.div`
    display: flex;
    justify-content: center;
`;

function getDomain(url: string): string {
    const domain = url.replace(/^(https?:\/\/)?(www\.)?/, '').split('/')[0];
    return domain;
}

export const EventCta = ({
    cta,
    story,
}: {
    cta: EventCtaFragment;
    story?: StoryToPlayFragment;
}) => {
    const { onTriggerEvent } = useTriggerEventContext();

    return (
        <Center>
            <Button
                colorScheme='white'
                onClick={() => {
                    onTriggerEvent({
                        event: Enum_Modals_Trigger.CtaClick,
                        filters: {
                            text: cta.Text,
                            storySlug: story?.Slug,
                        },
                    });
                }}
            >
                {cta.Text}
            </Button>
        </Center>
    );
};

const LinkCta = ({ cta }: { cta: LinkCtaFragment }) => {
    const { href } = useCtaDeeplink(cta.Url);

    return (
        <Center>
            <LinkButton
                colorScheme='white'
                variant='solid'
                url={href}
                text={cta.Text}
                type={cta.Redirection_Type}
                destinationName={getDomain(cta.Url)}
                destinationCategory={OutboundLinkDestinationCategory.Unknown}
                context={OutboundLinkContext.StoryPage}
                shape={OutboundLinkShape.Button}
            />
        </Center>
    );
};

export const CtaHandler = ({ cta }: Props) => {
    const { story } = useStoryContext();

    switch (cta.__typename) {
        case 'ComponentCtaEventCallToAction':
            return <EventCta cta={cta} story={story} />;

        case 'ComponentCtaLinkCallToAction':
            return <LinkCta cta={cta} />;

        default:
            return null;
    }
};
